interface AnalyticsFiltersProps {
  dateRange: string
  setDateRange: (value: string) => void
  selectedCampaign: string
  setSelectedCampaign: (value: string) => void
  segmentBy: 'device' | 'location' | 'emailClient' | 'cohort'
  setSegmentBy: (value: 'device' | 'location' | 'emailClient' | 'cohort') => void
  campaigns: Array<{ _id: string; subject: string }>
}

export default function AnalyticsFilters({
  dateRange,
  setDateRange,
  selectedCampaign,
  setSelectedCampaign,
  segmentBy,
  setSegmentBy,
  campaigns
}: AnalyticsFiltersProps) {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Date Range</label>
          <select
            value={dateRange}
            onChange={(e) => setDateRange(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-4 py-2"
          >
            <option value="7">Last 7 days</option>
            <option value="30">Last 30 days</option>
            <option value="90">Last 90 days</option>
            <option value="365">Last year</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Campaign</label>
          <select
            value={selectedCampaign}
            onChange={(e) => setSelectedCampaign(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-4 py-2"
          >
            <option value="all">All Campaigns</option>
            {campaigns.map(c => (
              <option key={c._id} value={c._id}>{c.subject}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Segment By</label>
          <select
            value={segmentBy}
            onChange={(e) => setSegmentBy(e.target.value as any)}
            className="w-full border border-gray-300 rounded-lg px-4 py-2"
          >
            <option value="device">Device</option>
            <option value="location">Location</option>
            <option value="emailClient">Email Client</option>
            <option value="cohort">Cohort</option>
          </select>
        </div>
      </div>
    </div>
  )
}
